<template>
  <div class="form-group" v-bind:class="(formerror.notice && formerror.notice[name]) ? 'has-danger' :''">
    <label v-if="label">{{label}}</label>
    <slot></slot>
    <div v-if="formerror.notice && formerror.notice[name]" class="form-control-feedback">{{formerror.notice[name]}}</div>
  </div>
</template>

<script>

export default {
  name: 'InputValidation',
  props: ['formerror', 'name', 'label'],
}
</script>



// WEBPACK FOOTER //
// src/components/lib/InputValidation.vue